import QueryString from "query-string";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import {
  GOOGLE_DRIVE_OAUTH_MESSAGE_FROM,
  GOOGLE_DRIVE_OAUTH_STORAGE_PREFIX,
} from "../../../../cores/googleDrive/connectApi";

function resolveOAuthState(state: string | string[] | null | undefined): {
  targetOrigin: string;
  sessionId: string | null;
} {
  if (typeof state === "string" && state.startsWith("http")) {
    return { targetOrigin: state, sessionId: null };
  }

  if (typeof state === "string") {
    try {
      const parsed = JSON.parse(state) as { origin?: string; sid?: string };
      if (typeof parsed.origin === "string" && parsed.origin.startsWith("http")) {
        return {
          targetOrigin: parsed.origin,
          sessionId: typeof parsed.sid === "string" ? parsed.sid : null,
        };
      }
    } catch {
      // legacy / invalid state
    }
  }

  return { targetOrigin: window.location.origin, sessionId: null };
}

export default function GoogleDrivePopUp() {
  const intl = useIntl();
  const { search } = useLocation();

  useEffect(() => {
    const params = QueryString.parse(search);
    const { code, error, error_description: errorDescription, state } = params;
    const { targetOrigin, sessionId } = resolveOAuthState(state);

    const payload = error
      ? {
          error,
          errorMessage:
            (errorDescription as string) ||
            intl.formatMessage({ id: "app.googleDrive.oauthError" }),
          from: GOOGLE_DRIVE_OAUTH_MESSAGE_FROM,
        }
      : code
        ? { code, from: GOOGLE_DRIVE_OAUTH_MESSAGE_FROM }
        : null;

    if (!payload) return;

    if (sessionId) {
      try {
        sessionStorage.setItem(
          `${GOOGLE_DRIVE_OAUTH_STORAGE_PREFIX}${sessionId}`,
          JSON.stringify(payload)
        );
      } catch {
        // ignore quota / private mode
      }
    }

    if (window.opener && !window.opener.closed) {
      try {
        window.opener.postMessage(payload, targetOrigin);
      } catch {
        // ignore cross-origin postMessage failures
      }
    }

    window.setTimeout(() => window.close(), 150);
  }, [search, intl]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <p className="text-muted mb-0">
        {intl.formatMessage({ id: "app.googleDrive.connecting" })}
      </p>
    </div>
  );
}
